import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import "./Guaranties.scss";
import "./Responsive.scss";

const Guaranties = () => {
    const [recaptch, setRecaptcha] = useState("");
    const breadCrumbData = [
        { title: "خانه", link: "/" },
        { title: "فعال سازی کد گارانتی", link: "/guaranties" },
    ];
    const recaptchHandler = (recaptchaValue) => {
        setRecaptcha(recaptchaValue);
    };
    return (
        <section className="guarantieWrapper mobile">
            <BreadCrumb breadCrumbData={breadCrumbData} />
            <div className="guarantieContent">
                <div className="desktop">
                    <div className="guarantieForm">
                        <div className="formHeader">
                            <p className="title">فعال سازی کد گارانتی</p>
                        </div>
                        <div className="formWrapper">
                            <div className="formGroup">
                                <div className="caption">
                                    <input type="text" name="" id="name" placeholder="" />
                                    <span className="placeholder">نام و نام خانوادگی *</span>
                                </div>
                            </div>
                            <div className="formGroup">
                                <div className="caption">
                                    <input type="text" name="" id="name" placeholder="" />
                                    <span className="placeholder">شماره تماس *</span>
                                </div>
                            </div>
                            <div className="formGroup">
                                <div className="caption">
                                    <input type="text" name="" id="name" placeholder="" />
                                    <span className="placeholder">کد گارانتی *</span>
                                </div>
                            </div>
                            <div className="formGroup">
                                <ReCAPTCHA size="invisible" sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt" onChange={recaptchHandler} />
                            </div>
                            <div className="formGroup">
                                <button type="submit" className="btnSend">فعال سازی</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default React.memo(Guaranties);
